import { ISelectListItem } from "../violation.interface"

export const reasonOptions = (t?: any): ISelectListItem[] => [
  {
    name: t("violation.unforseen_event_accident", "Unforeseen event (accident, weather conditions, broken bus...)"),
    id: 0
  },
  {
    name: t("violation.own_mistake_forgot_to_press_break", "Own mistake (forgot to press break, took too short a break, did not take responsibility for proper daily rest, forgot card on the bus...)"),
    id: 1
  },
  {
    name: t("violation.other_reason", "Other reason"),
    id: 2
  },
  {
    name: t("violation.drove_for_another_company", "Drove for another company"),
    id: 3
  }
]

export const exceptionOptions = (t?: any): ISelectListItem[] => [
  {
    name: t("violation.line_below_50", "Line below 50 km"),
    id: 0
  },
  {
    name: t("global.workshop", "Workshop"),
    id: 1
  },
  {
    name: t("violation.reserve_routine", "Reserve routine"),
    id: 2
  }
]
export const statusOptions = (t?: any): ISelectListItem[] => [
  {
    name: t("global.active", "Active"),
    id: 0
  },
  {
    name: t("global.ongoing", "Ongoing"),
    id: 1
  },
  {
    name: t("global.completed", "Completed"),
    id: 2
  }
]

